import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useProfileContext } from "context";
import { getWebsiteSettings, updateWebsiteSettings, retryWebsiteSync } from "api/bAIAssistantApi";

export function useWebsiteSettings() {
  const { userProfile } = useProfileContext();
  return useQuery({
    queryKey: ["ai-assistant", userProfile?.organisation_id, userProfile?.user_id, "website"],
    queryFn: getWebsiteSettings,
    enabled: !!userProfile?.user_id && userProfile?.user_role === "Owner",
    retry: false,
    refetchOnWindowFocus: false,
  });
}

export function useUpdateWebsiteSettings(retry = false) {
  const queryClient = useQueryClient();
  const { userProfile } = useProfileContext();
  const key = ["ai-assistant", userProfile?.organisation_id, userProfile?.user_id];
  return useMutation({
    mutationFn: retry ? retryWebsiteSync : updateWebsiteSettings,
    retry: false,
    onSuccess: (data) => queryClient.setQueryData([...key, "website"], data),
    onError: (error) => {
      if (error.response?.data?.settings) queryClient.setQueryData([...key, "website"], error.response.data.settings);
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: key }),
  });
}

export function useRetryWebsiteSync() {
  return useUpdateWebsiteSettings(true);
}
